import { isValidData } from '@/utils/formUtils';

const apiCfg = {
    forms: {
        index: {
            url: '/forms',
            method: 'get',
            params: {},
            data: {},
            // requiredData: ['filter'] // requiredData가 array형태면, 그냥 값이 있는지를 체크하면 됨
            requiredFns: {
                //requiredData가 object면 그 안의 parameter(function)으로 체크를 해야함
            },
        },
        /* 테이블 유저 정보 가져오기 */
        getFormUrl: {
            url: '/link',
            method: 'get',
            params: {
                campaignId: '',
            },
            data: {},
            requiredFns: {},
        },
        create: {
            url: `/forms/create`,
            method: 'post',
            params: {},
            data: {},
            requiredFns: {
                // header: [
                //     header => Array.isArray(header) && header.length >= 1  // need to have a title
                // ],
                // body: [
                //     body => Array.isArray(body) && body.length >= 2,  //default: name, email
                //
                //     body => body.every(ques => {
                //         const type = ques.type;
                //
                //         switch (type) {
                //             case 'short':
                //                 if (!ques.title) return console.log(type, 'is empty');
                //                 return true;
                //             case 'checkbox':
                //                 if (ques.choices && ques.choices.length < 1) return console.log(type, 'is zero choices');
                //                 return true;
                //             case 'multiple':
                //                 if (ques.choices && ques.choices.length < 1) return console.log(type, 'is zero choices');
                //                 return true;
                //             default:
                //                 return true;
                //         }
                //     })
                // ],
                // footer:  //foter는 나중에 sql 인젝션 방어를 위한 regrex코드를 넣어줘야함
            },
        },
        update: {
            url: `/forms/update`,
            method: 'put',
            params: {},
            data: {},
            requiredFns: {
                // filter:  [
                //     arr => Array.isArray(arr),
                //     arr => typeof arr.length === 'number' , // 0이면 모든 값이기 때문에, number로 타입체크를 하였음
                // ]
            },
        },
    },
};

const hasDataInMethod = (curApiCfg) =>
    (curApiCfg && curApiCfg.method === 'post') ||
    curApiCfg.method === 'put' ||
    curApiCfg.method === 'delete';

/*
 * url path가 추가되는 로직은 여기에다가 추가해놓기
 *
 * 참고) for in로 object를 돌리면 key(parameter)의 순서가 보장 되지 않음. 그래서 그냥 간단하게, 이렇게 직접 if로 넣어주는 방식 선택
 */
function updateUrl(curUrl, paths) {
    return (
        paths &&
        paths.reduce((acc, path) => ((acc = `${curUrl}/${path}`), acc), paths)
    );
}

/*
 * curApiCfg : 실제 사용할 설정 및 데이터값
 * data : curApiCfg에 필요한 내용들 넣고 버려질 값
 */
function createAxiosOpt(name, selectedCfg, { path, params, data }) {
    const curApiCfg = Object.assign({}, selectedCfg);
    curApiCfg.params = { ...curApiCfg.params, ...params };

    //url
    if (path.length) {
        curApiCfg.url = updateUrl(curApiCfg.url, path);
    }

    //reset data not required in body(post)
    if (hasDataInMethod(curApiCfg)) {
        curApiCfg.data = { ...curApiCfg.data, ...data };
    }

    return curApiCfg;
}

function apiFetch({
    url,
    method,
    params,
    data,
    cfg /* cfg는 특별히 axios 옵션을 설정하고 싶을때 넣는 object이다. */,
}) {
    const axiosCfg = {
        method: method,
        url: url,
        headers: { 'Content-Type': 'application/json' },
        params: params,
        data: data,
        timeout: 50000,
    };

    return axios(cfg ? Object.assign(axiosCfg, cfg) : axiosCfg).then(
        (res) => res.data
    );
}

function callApi(namespace, name, { path = [], params = {}, data = {} }) {
    // 여기서 url을 만들고, 나누는 작업을 해야함
    const curApiCfg = createAxiosOpt(name, apiCfg[namespace][name], {
        path,
        params,
        data,
    });

    if (!isValidData(curApiCfg.requiredFns || {}, { ...params, ...data }))
        throw new Error('cannot find body data required to api');

    //finalizeDataForm파라미터가 있으면, 데이터 형태를 가공해서 ajax요청을 보내는 부분임
    curApiCfg.data = curApiCfg.finalizeDataForm
        ? curApiCfg.finalizeDataForm(curApiCfg.data)
        : curApiCfg.data;

    return apiFetch(curApiCfg);
}

export default {
    callApi,
    isValidData,
};
